import { Controller } from "@hotwired/stimulus"
import Dropzone from "dropzone"

export default class extends Controller {
  connect() {
    this.dropzone = new Dropzone(this.element, {
      //url: this.element.action, // important: Dropzone needs to know where to POST
      url: this.element.action,
      paramName: "art[image]",
      dictDefaultMessage: "Drop files here to upload. Fill out form first, as art is automatically uploaded.",
      autoProcessQueue: true,
    });
  }
}
